<script>
export default {
  name: "NewBaremModal",
  props:{
    barem:{
      type: Array,
      default(){
        return []
      }
    },
    name:{
      type: String,
      default: () => ''
    },
    criterion: {
      type: Object,
      default: () => null
    }
  },
  methods:{
    setMark(point){
      this.criterion.point = point
    }
  }
}
</script>

<template>
  <b-modal :id="'ModalBarem'+name" :title="'Barem chấm điểm '" centered hide-footer
           ref="ModalBarem"
           size="xl">
    <div class="mt-5 table-responsive" style="height: auto ; max-height: 500px">
      <table class="table table-bordered  table-vertical-center ">
        <thead>
        <tr class="" style="background-color: #F8F8F8 ; font-size: 13px">
          <th style="width: 80%">Lời nhận xét</th>
          <th style="width: 20%" class="text-center">Hành động</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in barem" :key="index">
          <td :class="{'text-primary' : item.band === criterion?.point}">
            <p v-html="item?.eComment" style="white-space: pre-wrap;"></p>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-primary" @click="setMark(item.band)">
              Chọn
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<style scoped>

</style>